import { WordTitle, UpTitle } from "./WordTitle";

export const SecondaryHero = ({ uptitle, title, id }) => (
  <section id={id} className="px-6 md:px-14 py-32 md:py-52 text-center" data-testid={`secondary-hero-${id || "x"}`}>
    <UpTitle text={uptitle} />
    <h2 className="mt-10 font-serif text-4xl md:text-7xl lg:text-8xl leading-[1.02] text-white">
      <WordTitle lines={title} />
    </h2>
  </section>
);
